import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { MessageService } from '@corelabs/angular/messages';
import { TranslateService } from '@ngx-translate/core';
import { catchError, throwError } from 'rxjs';
import { upperSnakeToKebab } from '@shared/utils/text';
import { SKIP_ERROR_MESSAGE } from '../http-context';

const ignoredErrors = new Set(['SESSION_EXPIRED']);

interface ApiErrorBody {
    errors?: { title?: string }[];
}

export const apiErrorMessageInterceptor: HttpInterceptorFn = (req, next) => {
    if (req.context.get(SKIP_ERROR_MESSAGE)) {
        return next(req);
    }

    const messageService = inject(MessageService);
    const translateService = inject(TranslateService);

    return next(req).pipe(
        catchError((response: HttpErrorResponse) => {
            const errorTitle = (<ApiErrorBody | null>response.error)?.errors?.[0]?.title;

            if (errorTitle && !ignoredErrors.has(errorTitle)) {
                const translationKey = `error.${upperSnakeToKebab(errorTitle)}`;
                const translated = translateService.instant(translationKey);

                if (translated !== translationKey) {
                    messageService.add(translated, 'danger');
                } else {
                    messageService.add(translateService.instant('error.generic'), 'danger');
                }
            }

            return throwError(() => response);
        }),
    );
};
